"use strict";
exports.doNotTrack = [true, 'yes', '1'].indexOf(navigator.doNotTrack || navigator.msDoNotTrack || window.doNotTrack);
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = exports.doNotTrack;



//////////////////
// WEBPACK FOOTER
// ./node_modules/coveo.analytics/dist/donottrack.js
// module id = 311
// module chunks = 88 89